import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputAdornment, InputLabel, CircularProgress, Select, MenuItem } from "@material-ui/core";
import { panelUsersAuthStyle } from "../panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { updateRolAuth } from "../../domain/api/UsersApi";


export const FormChangeRol = ({ close, id }) => {

    const [isLoanding, setisLoanding] = useState(false)
    const classes = panelUsersAuthStyle();
    const dispath = useDispatch()




    return (
        <Formik

            initialValues={{
                rol: "",
            }}

            validate={(valores) => {

                let errores = {};

                if (!valores.rol) {
                    errores.rol = 'Por favor ingresa un rol'
                } else if (!/^[a-zA-Z0-9_.+-]{1,40}$/.test(valores.rol)) {
                    errores.rol = 'No se aceptan caracteres especiales ni números'
                }


                return errores;

            }}

            onSubmit={(valores, { resetForm }) => {
                setisLoanding(true);
                //cambio de rol
                updateRolAuth(dispath, id, valores.rol)
                    .then((response) => {
                    })
                    .catch((error) => {

                        console.error("Error del servicio: ", error);
                    })
                    .finally(() => {
                        setisLoanding(false);
                        close();
                        resetForm();
                    });
            }}
        >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="rol">Rol</InputLabel>
                                <Select
                                    id="rol"
                                    type="text"
                                    name='rol'
                                    defaultValue={values.rol}
                                    value={values.rol}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={60}
                                >
                                    <MenuItem value=""><em>Ninguno</em></MenuItem>
                                    <MenuItem value="ROLE_USER">Usuario</MenuItem>
                                    <MenuItem value="ROLE_ADMIN">Admin</MenuItem>
                                    <MenuItem value="ROLE_CLIENT">Cliente</MenuItem>
                                    <MenuItem value="ROLE_SUPPORT">Soporte</MenuItem>



                                </Select>
                            </FormControl>
                            {touched.rol && errors.rol && <div style={{ color: "red" }}>{errors.rol}</div>}
                        </Grid>
                    </Grid>
                    <div className={classes.wrapper}>
                        <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                            <Button
                                disabled={isLoanding}
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: "100%" }}
                            >
                                Actulizar rol
                            </Button>
                        </Grid>
                        {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </form>
            )}
        </Formik>
    );
}